angular.module('unergie.main')
.factory('AddrService', ($state, $uibModal) => {
    const openAddrModal = function (type, obj, callback) {
        const modalInstance = $uibModal.open({
            animation: true,
            size: 'xlg',
            controller: 'addrModalCtrl',
            templateUrl: '/states/addrModal/addrModal.html',
            resolve: {
                obj() {
                    return obj
                },
                type() {
                    return type
                },
            },
        })
        return modalInstance.result.then(callback)
    }

    return {
        openAddrModal,
    }
})
